import React, { FC, useMemo } from 'react';

import { EvSpinner } from '@evinced-private/ui-common';

import { SiteScannerTable } from '../../../../components/common/site-scanner-table/SiteScannerTable';
import {
	MANAGE_COLLECTIONS_FILTERS_ID,
	MANAGE_COLLECTIONS_TABLE_ID
} from '../../../../consts/PropertyCollection';
import { IProperty } from '../../../../interfaces/Property';
import { useCollections } from '../../../../providers/collections/CollectionsProvider';
import { useCommonFiltersStore } from '../../../../providers/commonFiltersProvider/CommonFiltersProvider';
import { useUserTenant } from '../../../../providers/userTenantProvider/UserTenantProvider';
import { getTableDefinition } from '../../helpers/ManageCollectionsTableHelper';
import { NoCollections } from '../no-collections/NoCollections';

interface IManageCollectionsTableProps {
	properties: IProperty[];
	isPropertiesLoading: boolean;
}

export const ManageCollectionsTable: FC<IManageCollectionsTableProps> = ({
	properties,
	isPropertiesLoading
}) => {
	const { hasAdminPermissions } = useUserTenant();
	const commonFiltersStore = useCommonFiltersStore();
	const { propertyCollections, isCollectionsLoading } = useCollections();

	const appliedFilters = commonFiltersStore.getFilterValue(MANAGE_COLLECTIONS_FILTERS_ID);
	const isNoCollections = !isCollectionsLoading && !propertyCollections.length;

	const isAdminUser = useMemo(hasAdminPermissions, [hasAdminPermissions]);
	const tableDefinition = useMemo(
		() =>
			getTableDefinition(propertyCollections, appliedFilters, {
				properties,
				isAdminUser
			}),
		[propertyCollections, appliedFilters, properties, isAdminUser]
	);

	if (isCollectionsLoading) {
		return <EvSpinner />;
	}

	return (
		<div>
			{isNoCollections ? (
				<NoCollections />
			) : (
				<SiteScannerTable
					key={`table-${properties.length}-${isPropertiesLoading}`}
					tableId={MANAGE_COLLECTIONS_TABLE_ID}
					tableData={tableDefinition.data}
					totalCount={tableDefinition.totalCount}
					totalPaginationableResults={tableDefinition.totalPaginationableResults}
					columns={tableDefinition.columns}
					options={tableDefinition.options}
				/>
			)}
		</div>
	);
};
